import template from './handoverPackSidebar.html';
import controller from './handoverPackSidebarCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    loanAppId: '<',
    currentFamilyId: '<',
    familyList: '<',
  },
};
